import { rankWith, scopeEndsWith } from '@jsonforms/core';

export default rankWith(
  5, //increase rank as needed
  scopeEndsWith('date')
);
